/**
 * @param {Object} props
 * @param {String} color - the colour for the arrow
 * @param {String} direction - the direction for the arrow
 * @returns an arrow
 */
const NaArrow = ({ color = '#999999', direction }) => {
  const isMobile = window.innerWidth < 768;

  const getRotation = direction => {
    if (direction.toLowerCase() == 'n') {
      return 270;
    } else if (direction == 'e') {
      return 0;
    } else if (direction == 's') {
      return 90;
    } else if (direction == 'w') {
      return 180;
    }
    return 0;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.09"
      height="16.006"
      viewBox="0 0 16.09 16.006"
      style={{ transform: `rotate(${getRotation(direction)}deg)` }}>
      <g
        id="Group_15504"
        data-name="Group 15504"
        transform="translate(-6.527 -6.556)">
        <path
          id="Path_9899"
          data-name="Path 9899"
          d="M14.571,6.556l-2.135,2.13,4.235,4.235H6.527V16.2H16.675L12.36,20.511l2.268,2.051,7.988-8.016Z"
          transform="translate(0 0)"
          fill={`${color}`}
        />
      </g>
    </svg>
  );
};
export default NaArrow;
